import { supabase } from './supabase';

/**
 * Save a generated image record to Supabase Storage + generated_images table.
 * Returns the public URL of the saved image.
 */
export const saveGeneratedImage = async (
    userId: string,
    blob: Blob,
    content: string
): Promise<string | null> => {
    const filename = `${userId}/${Date.now()}.png`;

    // Upload to Supabase Storage
    const { error: uploadError } = await supabase.storage
        .from('generated-images')
        .upload(filename, blob, { contentType: 'image/png' });

    if (uploadError) {
        console.error('Upload error:', uploadError.message);
        return null;
    }

    // Get public URL
    const { data: urlData } = supabase.storage
        .from('generated-images')
        .getPublicUrl(filename);

    const imageUrl = urlData.publicUrl;

    // Save record to database
    const { error: dbError } = await supabase.from('generated_images').insert({
        user_id: userId,
        image_url: imageUrl,
        content,
    });

    if (dbError) {
        console.error('DB insert error:', dbError.message);
        return null;
    }

    return imageUrl;
};

/** Fetch last N generated images for a user */
export const fetchUserImages = async (userId: string, limit = 20) => {
    const { data, error } = await supabase
        .from('generated_images')
        .select('*')
        .eq('user_id', userId)
        .order('created_at', { ascending: false })
        .limit(limit);

    if (error) return [];
    return data;
};

/** Delete an image record and its storage object */
export const deleteGeneratedImage = async (imageId: string, imageUrl: string): Promise<boolean> => {
    // Extract path from URL
    const parts = imageUrl.split('/generated-images/');
    const storagePath = parts[1];

    if (storagePath) {
        await supabase.storage.from('generated-images').remove([storagePath]);
    }

    const { error } = await supabase.from('generated_images').delete().eq('id', imageId);
    return !error;
};
